import {common, priority} from '@priority-software/priority-proto-api/lib';
import {formsStore} from '../../_legacy/Form/stores/FormsStore';
import {getDname} from '../../_shared/GWTBridge/invoke/genPage';
import {Column} from '../../stores/Form';

export type Values =
    | number
    | Long
    | null
    | string
    | boolean
    | common.IDate
    | common.ITimeOfDay
    | common.IDateTime
    | common.IFile;

const ColumnType = priority.netitems.form.ColumnType;

export const mapRecordByColumns = (
    records: priority.netitems.form.IRecord[],
    cols: {Columns: Column[]}
): Array<{[key: string]: Values}> => {
    const columnsMap = cols.Columns.reduce((map: {[key: number]: string}, curr) => {
        return typeof curr.ID === 'number' ? {...map, [curr.ID]: curr.Name} : map;
    }, {});

    return records.map(record => {
        return record.Fields.reduce((prevData: {[key: string]: Values}, currField) => {
            const fieldValue = Object.values(currField.Value)[0];
            const fieldId = currField.ColumnID;
            const fieldName = typeof fieldId === 'number' ? columnsMap[fieldId] : '';

            return fieldName ? {...prevData, [fieldName]: fieldValue} : prevData;
        }, {});
    });
};

export const getIDbyColumnName = (cols: priority.netitems.form.IColumn[], fieldName: string) => {
    const Column = findColumnByName(cols, fieldName);
    return Column?.ID;
};

export const findColumnByName = (cols: priority.netitems.form.IColumn[], fieldName: string) => {
    return cols.find(col => col.Name === fieldName);
};

export const mapRecordValue = (value: any | null, type?: priority.netitems.form.ColumnType) => {
    const columnTypeConst = getValueType(type);

    if (!columnTypeConst) {
        console.error('There is missing or incorrect Column Type');
        return {};
    }
    return new common.Constant({[columnTypeConst]: value});
};

export const getValueType = (columnType: priority.netitems.form.ColumnType): string => {
    const type = ColumnType[columnType];

    if (type === 'Attachment') {
        return 'File';
    } else if (type === 'Str' || type === 'Rstr') {
        return 'Str';
    } else if (type === 'Int') {
        return 'Int';
    } else if (type === 'Real') {
        return 'Real';
    } else if (type === 'Boolean') {
        return 'Boolean';
    }
    return '';
};

export const mapError = (e: Error, callback?: (...any) => void) => {
    return {
        name: e?.name,
        message: e?.message,
        handler: callback
    };
};

export const IsJsonString = (str: string = '') => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const getCompanyName = () => {
    const company = formsStore.currentForm?.formCompanyName || getDname();
    return company;
};
